import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Card, Grid, Segment } from 'semantic-ui-react'
import { compose } from 'recompose'

import MySearchesModuleHOC from './MySearchesModuleHOC'
import { withPermissions } from 'Components/Permissions'

import ErrorMassive from 'Components/ErrorMassive'
import MySearchesLayoutButtonGroup from 'Components/MySearchesLayoutButtonGroup'
import MySearchesTable from 'Components/MySearchesTable'
import PageHeaderRow from 'Components/PageHeaderRow'
import Pagination from 'Components/Pagination'
import SearchCard from 'Components/SearchCard'

import * as styles from './styles'

class MySearchesModule extends Component {
  static propTypes = {
    deleteSearch: PropTypes.func.isRequired,
    layout: PropTypes.string.isRequired,
    limit: PropTypes.number.isRequired,
    pagination: PropTypes.object.isRequired,
    searches: PropTypes.array.isRequired,
    setNameFilter: PropTypes.func.isRequired,
    setNameForm: PropTypes.func.isRequired,
    setPage: PropTypes.func.isRequired,
    setSortBy: PropTypes.func.isRequired,
    sortBy: PropTypes.string.isRequired,
    sortOrder: PropTypes.string.isRequired,
    toggleLayout: PropTypes.func.isRequired,
    toggleLimit: PropTypes.func.isRequired,
    toggleSortOrder: PropTypes.func.isRequired,
  }

  handleSort = column => {
    const { setSortBy, sortBy, toggleSortOrder } = this.props

    if (sortBy === column) {
      toggleSortOrder()
    } else {
      setSortBy(column)
    }
  }

  render() {
    const {
      deleteSearch,
      layout,
      limit,
      pagination,
      searches,
      setPage,
      sortBy,
      sortOrder,
      toggleLayout,
      toggleLimit,
      toggleSortOrder,
    } = this.props
    const mappedSearches = searches.map(s => <SearchCard deleteSearch={deleteSearch} key={s.id} search={s} />)

    return (
      <Grid>
        <PageHeaderRow title="My Searches" />

        <Grid.Row columns={1}>
          <Grid.Column width={16}>
            <Segment>
              {searches.length > 0 && (
                <div>
                  <MySearchesLayoutButtonGroup
                    handleSort={this.handleSort}
                    layout={layout}
                    limit={limit}
                    sortBy={sortBy}
                    sortOrder={sortOrder}
                    toggleLayout={toggleLayout}
                    toggleLimit={toggleLimit}
                    toggleSortOrder={toggleSortOrder}
                  />

                  <br />
                </div>
              )}

              {layout === 'gridLayout' && (
                <Card.Group itemsPerRow={6} stackable style={styles.cardGroupStyle}>
                  {mappedSearches}
                </Card.Group>
              )}

              {layout === 'tableLayout' && (
                <MySearchesTable
                  deleteSearch={deleteSearch}
                  fromPage="myOrders"
                  handleSort={this.handleSort}
                  searches={searches}
                  sortBy={sortBy}
                  sortOrder={sortOrder}
                  toggleSortOrder={toggleSortOrder}
                />
              )}

              {searches.length > 0 && (
                <div>
                  <br />
                  <Pagination
                    itemName="search"
                    items={pagination.totalSearches}
                    page={pagination.page}
                    pages={pagination.pages}
                    setPage={setPage}
                  />
                </div>
              )}

              <ErrorMassive
                enabled={searches.length === 0}
                message="No searches found. You can save searches from the search module. Just click the save button after you set-up all parameters."
              />
            </Segment>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    )
  }
}

const composed = compose(
  withPermissions('modules.mySearches'),
  MySearchesModuleHOC,
)

export default composed(MySearchesModule)
